__turbopack_context__.v({
  "body": "FAmxeq_body",
  "button": "FAmxeq_button",
  "emailInput": "FAmxeq_emailInput",
  "emailLabel": "FAmxeq_emailLabel",
  "errorMessage": "FAmxeq_errorMessage",
  "form": "FAmxeq_form",
  "inputContainer": "FAmxeq_inputContainer",
  "noError": "FAmxeq_noError",
  "successMessage": "FAmxeq_successMessage",
  "svg": "FAmxeq_svg",
});
